import React from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'antd';
import {
  UpOutlined,
  BulbOutlined,
} from '@ant-design/icons';

export class DrawerExplanation extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    explanation: PropTypes.string.isRequired,
  };

  renderIcon = ({ isActive }) => (
    isActive ? <UpOutlined className="text-primary" /> : <BulbOutlined className="text-primary" />
  );

  render() {
    const { title, explanation } = this.props;
    return (
      <Collapse
        bordered={false}
        defaultActiveKey={[]}
        className="drawer__explanation mb-1 bg-transparent"
        expandIcon={this.renderIcon}
        expandIconPosition="right"
      >
        <Collapse.Panel header={title}>
          <div className="text-secondary small text-justify">{explanation}</div>
        </Collapse.Panel>
      </Collapse>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/editor/DrawerExplanation.jsx